import React from "react";
import Slider from "react-slick";
import css from "./FindTutorCard.module.css";
import testimonialImage from '../../../../../assets/Testimonial-Image.png';
import testimonialImage2 from '../../../../../assets/Testimonial-Image2.png';
import testimonialImage3 from '../../../../../assets/Testimonial-Image-3.png';
import testimonialImage4 from '../../../../../assets/Testimonial-Image-4.png';
import IconCard from "../../../../../components/SavedCardDetails/IconCard/IconCard";
import { FormattedMessage, injectIntl, intlShape } from '../../../../../util/reactIntl';

function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{ ...style, display: "block" }}
            onClick={onClick}
        >
            <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.5 27C20.9558 27 27 20.9558 27 13.5C27 6.04416 20.9558 0 13.5 0C6.04416 0 0 6.04416 0 13.5C0 20.9558 6.04416 27 13.5 27Z" fill="#1C3533" />
                <path d="M11.1372 18.2249L15.8622 13.4999L11.1372 8.7749" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </div>
    );
}

function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{ ...style, display: "block" }}
            onClick={onClick}
        >
            <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.5 27C6.04416 27 0 20.9558 0 13.5C0 6.04416 6.04416 0 13.5 0C20.9558 0 27 6.04416 27 13.5C27 20.9558 20.9558 27 13.5 27Z" fill="#1C3533" />
                <path d="M15.8628 18.2249L11.1378 13.4999L15.8628 8.7749" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </div>
    );
}

const tutors = [
    {
        id: 1,
        nameId: "FindTutorCard.tutor1.name",
        quoteId: "FindTutorCard.tutor1.quote",
        detailsId: "FindTutorCard.tutor1.details",
        img: testimonialImage,
    },
    {
        id: 2,
        nameId: "FindTutorCard.tutor2.name",
        quoteId: "FindTutorCard.tutor2.quote",
        detailsId: "FindTutorCard.tutor2.details",
        img: testimonialImage2,
    },
    {
        id: 3,
        nameId: "FindTutorCard.tutor3.name",
        quoteId: "FindTutorCard.tutor3.quote",
        detailsId: "FindTutorCard.tutor3.details",
        img: testimonialImage3,
    },
    {
        id: 4,
        nameId: "FindTutorCard.tutor4.name",
        quoteId: "FindTutorCard.tutor4.quote",
        detailsId: "FindTutorCard.tutor4.details",
        img: testimonialImage4,
    },
];
const paddedTutors =
    tutors.length < 3
        ? [...tutors, ...Array(3 - tutors.length).fill({ isPlaceholder: true })]
        : tutors;

const settings = {
    dots: false,
    // infinite: paddedTutors.length > 3,
    infinite: false,
    speed: 600,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: tutors.length > 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                // infinite: tutors.length > 2
                infinite: false
            },
        },
        {
            breakpoint: 640,
            settings: {
                slidesToShow: 1.1,
                infinite: false,
                dots: true
            },
        },
    ],
};


function FindTutorCard() {
    return (
        <div className={css.sliderWrapper}>
            <h2 className={css.heading}>
                <FormattedMessage id="OurCategories.findTutor" />
            </h2>
            <div className={css.subheading}>
                <FormattedMessage id="OurCategories.yourNeeds" />
            </div>
            <div className={css.sliderContainer}>
                <Slider {...settings}>
                    {tutors.map((tutor, i) => {
                        return (
                            <div key={tutor.id} className={css.card}>
                                <div className={`${css.cardContent} ${tutor.bg || ""}`}>
                                    <div className={css.cardTop}>
                                        <div
                                            className={css.quote}
                                            style={{ color: i % 2 === 0 ? '#00674F' : '#00316E' }}
                                        >
                                            "<FormattedMessage id={tutor.quoteId} />"
                                        </div>
                                        <div className={css.details}>
                                            <FormattedMessage id={tutor.detailsId} />
                                        </div>
                                    </div>
                                    <div className={css.tutorInfo}>
                                        <img src={tutor.img} alt="tutor" />
                                        <span className={css.name}>
                                            <FormattedMessage id={tutor.nameId} />
                                        </span>
                                        <a href="#" className={css.hoverButon}>
                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill="none" d="M11.6668 12.25V11.0833C11.6668 10.4645 11.421 9.871 10.9834 9.43342C10.5458 8.99583 9.95233 8.75 9.3335 8.75H4.66683C4.04799 8.75 3.4545 8.99583 3.01691 9.43342C2.57933 9.871 2.3335 10.4645 2.3335 11.0833V12.25" stroke="#00674F" strokeLinecap="round" strokeLinejoin="round" />
                                                <path fill="none" d="M6.99984 6.41667C8.2885 6.41667 9.33317 5.372 9.33317 4.08333C9.33317 2.79467 8.2885 1.75 6.99984 1.75C5.71117 1.75 4.6665 2.79467 4.6665 4.08333C4.6665 5.372 5.71117 6.41667 6.99984 6.41667Z" stroke="#00674F" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                            <FormattedMessage id="OurCategories.viewProfile" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </Slider>
                <button className={css.ctaBtn}>
                    <FormattedMessage id="OurCategories.joinUsToday" />
                    <IconCard type="rightarrow" />
                </button>
            </div>
        </div>
    );
};

export default FindTutorCard;